<template>
  <program-create-form></program-create-form>
</template>

<script>
import ProgramCreateForm from "./CreateForm";
export default {
  name: "CreateProgramPage",
  components: { ProgramCreateForm }
};
</script>

<style scoped></style>
